import './tooltip.css';
export var tooltipAnimationWrapperCSS = '_hplwyr2-3-8-0';
export var tooltipElementCSS = '_hplwyr1-3-8-0';
export var tooltipOffsetVar = 'var(--_hplwyr0-3-8-0)';